import moment, { Moment } from "moment/moment";

import { Direction, ThumbRangeDaysWidth } from "./types";

export const calculateEdgeDate = (
  direction: Direction,
  deltaX: number,
  rangeDaysWidth: ThumbRangeDaysWidth,
  rangeStart: string,
  rangeEnd: string,
  thumbStartDate: string,
  thumbEndDate: string,
  calendarStartDate: string,
  calendarEndDate: string
): Moment | string | null => {
  const dayWidth = deltaX < 0 ? rangeDaysWidth[direction].back : rangeDaysWidth[direction].forward;
  if (dayWidth === 0) {
    return null;
  }
  const currentEdgeDate = direction === Direction.Right ? moment.utc(rangeEnd) : moment.utc(rangeStart);
  const newEdgeDate = currentEdgeDate.add(Math.floor(deltaX / dayWidth), "days");
  return direction === Direction.Right
    ? calculateEndDate(newEdgeDate, calendarEndDate, thumbStartDate)
    : calculateStartDate(newEdgeDate, calendarStartDate, thumbEndDate);
};

const calculateStartDate = (
  newStartDate: Moment,
  calendarStartDate: string,
  thumbEndDate: string
): Moment | string | null => {
  if (newStartDate.isBefore(calendarStartDate)) {
    return calendarStartDate;
  }
  if (newStartDate.isAfter(thumbEndDate)) {
    return thumbEndDate;
  }
  if (newStartDate.isBetween(calendarStartDate, thumbEndDate, null, "[]")) {
    return newStartDate;
  }
  return null;
};

const calculateEndDate = (
  newEndDate: Moment,
  calendarEndDate: string,
  thumbStartDate: string
): Moment | string | null => {
  if (newEndDate.isAfter(calendarEndDate)) {
    return calendarEndDate;
  }
  if (newEndDate.isBefore(thumbStartDate)) {
    return thumbStartDate;
  }
  if (newEndDate.isBetween(thumbStartDate, calendarEndDate, null, "[]")) {
    return newEndDate;
  }
  return null;
};
